export function fromDate(date) {
    var d = new Date(+date);
    return asValidDateOrNull(d);
}
export function fromDateOrThrow(date) {
    var d = new Date(date instanceof Date ? date.getTime() : date);
    return asValidDateOrThrow(d, date);
}
export function asValidDateOrNull(date) {
    if (isValidDate(date))
        return date;
    return null;
}
export function asValidDateOrThrow(date, origin) {
    if (isValidDate(date))
        return date;
    throw new TypeError("Cant parse date from \"" + origin + "\"");
}
export var newValidDate = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var result = new ((_a = Date).bind.apply(_a, [void 0].concat(args)))();
    return asValidDateOrNull(result);
    var _a;
};
export var newValidDateOrThrow = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var result = new ((_a = Date).bind.apply(_a, [void 0].concat(args)))();
    return asValidDateOrThrow(result, args);
    var _a;
};
export function isValidDate(d) {
    return d !== null && d instanceof Date && isFinite(d.getTime());
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-date/esm/src/create/create-ts-date.js
// module id = null
// module chunks = 